import Crud from './crud'
import { request_list, export_list, export_detail } from '@/commons/hpod';
var FileSaver = require('file-saver');
import Vue from 'vue';
var crud = new Crud('bills', 'xuất hàng');

const state = {
    ...crud.state,
    selected: {
        ID: 0,
        Products: []
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    exportList({ commit }, param) {
        export_list('bills', res => {
            var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"});
            FileSaver.saveAs(blob, `DanhSachBill_${new Date().getTime()}.xlsx`);
        }, Vue.http, param, this.state.authentication.token, 'export_list');
    },
    exportDetail({ commit }, param) {
        export_detail('bills', res => {
            var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"});
            FileSaver.saveAs(blob, `Bill_${new Date().getTime()}.xlsx`);
        }, Vue.http, param, this.state.authentication.token, 'export');
    }
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
